"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = exports.initialFilterOptions = exports.initialOrderByOptions = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const Actions = require("../../actionTypes/user/projects");
exports.initialOrderByOptions = {
    orderBy: 'id',
    order: 'desc'
};
exports.initialFilterOptions = {};
exports.initialState = {
    status: 'STANDBY',
    copyStatus: 'STANDBY',
    error: undefined,
    list: [],
    isOpen: false,
    user: null,
    orderByOptions: Object.assign({}, exports.initialOrderByOptions),
    filterOptions: Object.assign({}, exports.initialFilterOptions),
    searchString: '',
    allSelected: false,
    selectedProjects: [],
    users: [],
    usersStatus: 'STANDBY',
    selectedUsers: []
};
//#endregion
//#region LENS
const statusLens = monocle.Lens.fromProp('status');
const listLens = monocle.Lens.fromProp('list');
const errorLens = monocle.Lens.fromProp('error');
const isOpenLens = monocle.Lens.fromProp('isOpen');
const userLens = monocle.Lens.fromProp('user');
const orderByOptionsLens = monocle.Lens.fromProp('orderByOptions');
const filterOptionsLens = monocle.Lens.fromProp('filterOptions');
const searchStringLens = monocle.Lens.fromProp('searchString');
const toggleSelectLens = monocle.Lens.fromProp('selectedProjects');
const allSelectedLens = monocle.Lens.fromProp('allSelected');
const usersLens = monocle.Lens.fromProp('users');
const usersStatusLens = monocle.Lens.fromProp('usersStatus');
const selectedUsersLens = monocle.Lens.fromProp('selectedUsers');
const copyStatusLens = monocle.Lens.fromProp('copyStatus');
const methods = {};
exports.methods = methods;
methods[Actions.FETCH_PROJECTS_REQUEST] = (state, action) => fp.function.compose(statusLens.set('FETCHING'), isOpenLens.set(true), userLens.set(action.payload))(state);
methods[Actions.FETCH_PROJECTS_SUCCESS] = (state, action) => fp.function.compose(statusLens.set('FETCHED'), listLens.set(action.payload))(state);
methods[Actions.FETCH_PROJECTS_FAILED] = (state, action) => fp.function.compose(statusLens.set('FAILED'), errorLens.set(action.payload))(state);
methods[Actions.CLEAR] = () => (Object.assign({}, exports.initialState));
methods[Actions.SET_ORDER_BY_OPTIONS] = (state, action) => orderByOptionsLens.set(action.payload)(state);
methods[Actions.SET_FILTER_OPTIONS] = (state, action) => filterOptionsLens.modify((filters) => {
    const copy = Object.assign({}, filters);
    if (action.payload.value) {
        copy[action.payload.filter] = action.payload.value;
    }
    else {
        delete copy[action.payload.filter];
    }
    return copy;
})(state);
methods[Actions.SET_SEARCH_STRING] = (state, action) => searchStringLens.set(action.payload.searchString)(state);
methods[Actions.TOGGLE_SELECT] = (state, action) => {
    let allSelected = action.payload.ids.length === state.list.length;
    return fp.function.compose(toggleSelectLens.modify((list) => {
        if (allSelected) {
            return action.payload.ids;
        }
        else if (action.payload.ids.length === 0) {
            return [];
        }
        else {
            const l = [...list];
            const fileId = action.payload.ids[0];
            const i = l.findIndex((x) => x === fileId);
            if (i === -1) {
                l.push(fileId);
            }
            else {
                l.splice(i, 1);
            }
            allSelected = state.list.length === l.length;
            return l;
        }
    }), allSelectedLens.set(allSelected))(state);
};
methods[Actions.FETCH_USER_SUCCESS] = (state, action) => fp.function.compose(usersLens.set(action.payload.users), usersStatusLens.set('FETCHED'))(state);
methods[Actions.FETCH_USER_FAILED] = (state, action) => fp.function.compose(usersLens.set([]), usersStatusLens.set('FAILED'))(state);
methods[Actions.FETCH_USER_REQUEST] = (state, action) => fp.function.compose(usersLens.set([]), usersStatusLens.set('FETCHING'))(state);
methods[Actions.SELECT_USER] = (state, action) => selectedUsersLens.modify((l) => l.includes(action.payload.user) ? l : [...l, action.payload.user])(state);
methods[Actions.REMOVE_USER] = (state, action) => selectedUsersLens.modify((l) => l.filter((u) => u.uuid !== action.payload.user.uuid))(state);
methods[Actions.COPY_PROJECT_PERMISSIONS] = (state, action) => copyStatusLens.set('COPYING')(state);
methods[Actions.COPY_PROJECT_PERMISSIONS_SUCCESS] = (state, action) => copyStatusLens.set('COPIED')(state);
methods[Actions.COPY_PROJECT_PERMISSIONS_FAILURE] = (state, action) => copyStatusLens.set('FAILED')(state);
//# sourceMappingURL=projects.js.map